export const MAIL_ATTACHMENT_ATTACHED = 'attachment';
export const MAIL_ATTACHMENT_INLINE = 'inline';
export const MAIL_MODULE_KEY = 'mails';
export const MAIL_FILTER_KEY = 'mails';
export const MAIL_STATUS_PENDING = 'pending';
export const MAIL_STATUS_SENT = 'sent';
